import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { RouterLink } from 'src/routes/components';

import LogoImg from './3.svg';
// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: { xs: 1, md: 1 },
        height: { xs: 1, md: 1 },
        // p: { xs: 0, md: 2 },
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <img decoding="async" loading="lazy" src={LogoImg} alt="hakeemna" />

      {/* <img decoding="async" loading="lazy" src="/logo/doc.webp" alt="logo" /> */}
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
